export default "__VITE_ASSET__C3$r1TmC__"